var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForestXColor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 202.66667,
    height: 46.666668,
    viewBox: "0 0 202.66667 46.666668",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,350 H 1512 V 0 H 0 Z",
    id: "path3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,350 H 1512 V 0 H 0 Z",
    id: "path5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,350 H 1512 V 0 H 0 Z",
    id: "path7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,350 H 1512 V 0 H 0 Z",
    id: "path9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,350 H 1512 V 0 H 0 Z",
    id: "path11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,350 H 1512 V 0 H 0 Z",
    id: "path13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,350 H 1512 V 0 H 0 Z",
    id: "path15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,350 H 1512 V 0 H 0 Z",
    id: "path17"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-R5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m 1511.05,6.71875 h -75.36 L 1235.52,342.75 h 74.88 L 1511.05,6.71875",
    style: {
      fill: "#66c35e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,46.666667)",
    clipPath: "url(#clipPath3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "m 1305.12,6.71875 h -74.89 L 1430.41,342.75 h 74.88 L 1305.12,6.71875",
    style: {
      fill: "#132338",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,46.666667)",
    clipPath: "url(#clipPath5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "m 147.371,289.941 c -34.086,2.403 -50.8866,-11.039 -50.8866,-40.8 v -2.403 H 147.371 V 187.219 H 96.4844 V 6.71875 H 34.5586 V 187.219 H 0 v 59.519 h 34.5586 v 2.403 c 0,67.687 37.9258,104.648 112.8124,100.328 v -59.528",
    style: {
      fill: "#132338",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,46.666667)",
    clipPath: "url(#clipPath7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "m 281.879,60.4805 c 18.719,0 34.082,6.2383 46.562,18.7187 12.481,12.4805 18.719,28.3318 18.719,47.5308 0,19.204 -6.238,35.043 -18.719,47.524 -12.48,12.48 -27.843,18.723 -46.562,18.723 -18.723,0 -34.082,-6.243 -46.563,-18.723 -12.003,-12.481 -18.242,-28.32 -18.242,-47.524 0,-19.199 6.239,-35.0503 18.242,-47.5308 12.481,-12.4804 27.84,-18.7187 46.563,-18.7187 z M 281.879,0 c -35.524,0 -65.766,11.9922 -90.25,36.4766 -24.481,24.4804 -36.484,54.7265 -36.484,90.2534 0,35.524 12.003,65.29 36.484,89.77 24.484,24.477 54.726,36.965 90.25,36.965 35.523,0 65.766,-12.488 90.25,-36.965 24.476,-24.48 36.961,-54.246 36.961,-89.77 0,-35.5269 -12.485,-65.773 -36.961,-90.2534 C 347.645,11.9922 317.402,0 281.879,0",
    style: {
      fill: "#132338",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,46.666667)",
    clipPath: "url(#clipPath9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "m 497.852,205.457 c 11.515,30.723 40.32,46.082 72.961,46.082 v -69.125 c -18.719,2.402 -36,-1.441 -50.883,-11.519 -14.883,-10.082 -22.078,-26.403 -22.078,-49.442 V 6.71875 h -61.93 V 246.738 h 61.93 v -41.281",
    style: {
      fill: "#132338",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,46.666667)",
    clipPath: "url(#clipPath11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "m 766.66,149.293 c -7.203,32.641 -31.207,48.48 -59.527,48.48 -33.125,0 -55.684,-17.757 -62.887,-48.48 z M 645.207,101.289 c 8.16,-30.2421 30.723,-45.1249 67.688,-45.1249 23.519,0 41.761,8.164 53.765,24.0039 L 816.582,51.3594 C 793.066,17.2773 758.016,0 711.934,0 672.09,0 640.402,11.9922 616.406,35.9961 592.402,60 580.398,90.2461 580.398,126.73 c 0,36.004 12.004,66.247 35.524,90.25 23.523,24.481 54.246,36.485 91.211,36.485 35.043,0 64.332,-12.004 86.89,-36.485 23.036,-24.484 34.559,-54.246 34.559,-90.25 0,-8.16 -0.957,-16.32 -2.402,-25.441 H 645.207",
    style: {
      fill: "#132338",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,46.666667)",
    clipPath: "url(#clipPath13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "m 958.184,152.176 c 35.039,-7.203 80.646,-24.004 80.166,-75.3674 0,-24.4844 -9.12,-43.6914 -27.84,-57.1289 C 992.266,6.71875 969.219,0 941.855,0 892.41,0 858.809,19.1992 841.043,57.1211 l 53.77,30.2422 c 7.199,-20.6445 22.558,-31.1992 47.042,-31.1992 22.09,0 33.125,6.7187 33.125,20.6445 0,12.957 -19.199,20.1602 -43.683,26.4024 -35.527,9.121 -80.176,23.996 -80.176,73.926 0,23.519 8.645,42.238 25.93,55.683 17.762,13.918 39.363,20.645 65.293,20.645 38.875,0 72.476,-18.242 91.196,-50.887 l -52.798,-28.801 c -7.676,16.317 -20.644,24.481 -38.398,24.481 -15.852,0 -27.844,-7.68 -27.844,-19.684 0,-12.961 19.199,-20.16 43.684,-26.398",
    style: {
      fill: "#132338",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,46.666667)",
    clipPath: "url(#clipPath15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "m 1209.61,187.219 h -54.25 V 87.3633 c 0,-25.918 18.73,-26.4063 54.25,-24.4805 V 6.71875 C 1124.64,-2.87891 1093.44,21.6016 1093.44,87.3633 v 99.8557 h -41.76 v 59.519 h 41.76 v 48.489 l 61.92,18.718 v -67.207 h 54.25 v -59.519",
    style: {
      fill: "#132338",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,46.666667)",
    clipPath: "url(#clipPath17)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForestXColor);
export default __webpack_public_path__ + "static/media/forest_x_color.87d651dd63a62e7538ca8c0996d87e90.svg";
export { ForwardRef as ReactComponent };